import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { NAV, SITE } from "@/lib/site";
import Logo from "@/components/Logo";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const FooterCol = ({ title, children }) => (
 <div>
 <div className="text-[11px] uppercase tracking-[0.24em] font-bold text-[#4A4A4A] mb-4">
 {title}
 </div>
 <div className="flex flex-col gap-2.5">{children}</div>
 </div>
);

export const Footer = () => {
 return (
 <footer className="bg-white border-t border-[#EAEAEA]" data-testid="site-footer">
 <div className="h-1 w-full bg-[#FDD805]" />
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
 <div className="md:col-span-2">
 <Logo height={80} />
 <p className="mt-6 text-[15px] leading-relaxed text-[#1C1F26] max-w-md">
 A founder-first partner for First-Time Founders across Mumbai, Navi Mumbai, Thane and the MMRDA region. We help you
 choose the right business structure, complete essential registrations
 and build the right foundation for launch with expert handholding.
 </p>
 </div>

 <FooterCol title="Explore">
 {NAV.map((n) => (
 <Link
 key={n.to}
 to={n.to}
 className="text-[14px] text-[#0F1115] hover:text-[#0F1115] link-underline w-fit"
 data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
 >
 {n.label}
 </Link>
 ))}
 </FooterCol>

 <FooterCol title="Reach us">
 <a href={`mailto:${SITE.email}`} className="text-[14px] text-[#0F1115] inline-flex items-center gap-2 hover:text-[#0F1115]" data-testid="footer-email">
 <Mail size={14} className="text-[#FDD805]" /> {SITE.email}
 </a>
 <a href={`tel:${SITE.whatsappNumber}`} className="text-[14px] text-[#0F1115] inline-flex items-center gap-2" data-testid="footer-phone">
 <Phone size={14} className="text-[#FDD805]" /> {SITE.phone}
 </a>
 <div className="text-[14px] text-[#0F1115] inline-flex items-start gap-2">
 <MapPin size={14} className="text-[#FDD805] mt-1 shrink-0" />
 <span className="whitespace-pre-line">{SITE.address}</span>
 </div>
 <a
 href={SITE.whatsappUrl}
 target="_blank"
 rel="noreferrer"
 className="mt-3 bg-[#25D366] text-white rounded-full px-5 py-2.5 font-bold text-sm inline-flex items-center justify-center gap-2 w-fit hover:bg-[#1EBE57] hover:-translate-y-0.5 transition-all"
 data-testid="footer-whatsapp-cta"
 >
 <WhatsAppIcon size={15} /> Chat
 </a>
 </FooterCol>
 </div>
 <div className="border-t border-[#EAEAEA]">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
 <div className="text-[12px] text-[#4A4A4A]">
 © {new Date().getFullYear()} HG Corporates Founded by {SITE.founder}. All rights reserved.
 </div>
 <div className="text-[12px] text-[#4A4A4A]">
 Made with care for First-Time Founders across Mumbai, Navi Mumbai, Thane and the MMRDA region.
 </div>
 </div>
 </div>
 </footer>
 );
};

export default Footer;
